// Add your custom JS here.
import Swiper from "swiper";
import {
	Autoplay,
	Navigation,
	Pagination,
	EffectFade,
	Keyboard,
} from "swiper/modules";
import "uikit/dist/js/uikit.min.js";

document.addEventListener("DOMContentLoaded", () => {
	// Menu Scrolling
	const navbar = document.getElementById("wrapper-navbar");
	let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

	// Check scroll position on load
	if ((window.pageYOffset || document.documentElement.scrollTop) > 50) {
		navbar.classList.add("scrolled");
	} else {
		navbar.classList.remove("scrolled");
	}

	window.addEventListener("scroll", function () {
		const currentScroll =
			window.pageYOffset || document.documentElement.scrollTop;

		if (currentScroll > 50) {
			navbar.classList.add("scrolled");
		} else {
			navbar.classList.remove("scrolled");
		}

		lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Safari
	});

	// Image Carousel Block
	function loadVisibleBackgrounds(swiper) {
		const slides = swiper.slides;
		const activeIndex = swiper.activeIndex;

		// Load background for active + adjacent slides for smooth transition
		[activeIndex - 1, activeIndex, activeIndex + 1].forEach((i) => {
			const slide = slides[i];
			if (slide && slide.dataset.bg && !slide.style.backgroundImage) {
				slide.style.backgroundImage = `
					linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
					url(${slide.dataset.bg})
				`;
			}
		});
	}

	document.querySelectorAll(".image-carousel-swiper").forEach((carousel) => {
		const swiper = new Swiper(carousel, {
			loop: true,
			modules: [Autoplay, Pagination, Navigation, EffectFade],
			autoplay: { delay: 5000, disableOnInteraction: false },
			slidesPerView: 1,
			spaceBetween: 0,
			effect: "fade",
			draggable: false,
			allowTouchMove: false,
			simulateTouch: false,
			speed: 800,
			pagination: {
				el: carousel.querySelector(".swiper-pagination"),
				clickable: true,
			},
			navigation: {
				nextEl: carousel.querySelector(".swiper-button-next"),
				prevEl: carousel.querySelector(".swiper-button-prev"),
			},
			on: {
				init: function () {
					loadVisibleBackgrounds(this);
				},
				slideChange: function () {
					loadVisibleBackgrounds(this);
				},
			},
		});
	});

	// Find all gallery blocks on the page
	const galleryBlocks = document.querySelectorAll(".block-gallery");

	if (galleryBlocks.length) {
		// Append modal to body to avoid nesting issues
		const bsModalEl = document.getElementById("galleryModal");
		if (bsModalEl && bsModalEl.parentNode !== document.body) {
			document.body.appendChild(bsModalEl);
		}

		// Initialize each gallery block
		galleryBlocks.forEach((block) => {
			initGalleryBlock(block);
		});

		function initGalleryBlock(block) {
			const collectionsData = JSON.parse(block.dataset.collections);
			const collectionsLinks = block.querySelectorAll("[data-gallery-target]");
			const slider = block.querySelector(".gallery-slider");
			const modal = document.getElementById("galleryModal");
			const swiperWrapper = modal.querySelector(".swiper-wrapper");

			let currentImages = [];
			let clickedImageId = null;
			let modalSwiper = null;

			function normalizeHashValue(value) {
				return decodeURIComponent(value || "")
					.replace(/^#/, "")
					.trim()
					.toLowerCase();
			}

			function getCollectionIndexFromHash(hash) {
				const normalizedHash = normalizeHashValue(hash);
				if (!normalizedHash) {
					return -1;
				}

				const index = collectionsData.findIndex((collection) => {
					const slug = normalizeHashValue(collection.slug || "");
					const title = normalizeHashValue(collection.title || "");
					return normalizedHash === slug || normalizedHash === title;
				});

				return index;
			}

			function updateUrlHashForCollection(index) {
				const collection = collectionsData[index];
				if (!collection) {
					return;
				}

				const slug = (collection.slug || "").trim();
				if (!slug) {
					return;
				}

				const shouldClearHash = normalizeHashValue(slug) === "all";
				const newUrl = shouldClearHash
					? `${window.location.pathname}${window.location.search}`
					: `${window.location.pathname}${window.location.search}#${encodeURIComponent(
							slug,
					  )}`;

				if (newUrl !== `${window.location.pathname}${window.location.search}${window.location.hash}`) {
					history.replaceState(null, "", newUrl);
				}
			}

			function setActiveCollection(index, options = {}) {
				const { scroll = false, syncHash = false } = options;

				collectionsLinks.forEach((a) => a.classList.remove("active"));
				const activeLink = block.querySelector(`[data-gallery-target="${index}"]`);
				if (activeLink) {
					activeLink.classList.add("active");
				}

				renderGallery(index);

				if (syncHash) {
					updateUrlHashForCollection(index);
				}

				if (scroll && block) {
					const offset = 120;
					const top =
						block.getBoundingClientRect().top + window.pageYOffset - offset;
					window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
				}
			}

			// Render gallery images for a given collection index
			function renderGallery(collectionIndex) {
				const images = collectionsData[collectionIndex]?.images || [];

				// Clear existing grid
				slider.innerHTML = "";

				images.forEach((img) => {
					const div = document.createElement("div");
					div.className = "col";
					div.setAttribute("data-image-id", img.id);
					div.setAttribute("data-image-url", img.url);
					div.setAttribute("role", "button");
					div.setAttribute("data-bs-toggle", "modal");
					div.setAttribute("data-bs-target", "#galleryModal");

					div.innerHTML = `
          <div class="ratio ratio-gallery scale-on-hover opacity-on-hover">
            <img src="${img.thumb}" alt="${
							img.alt || ""
						}" class="object-fit-cover" />
          </div>
        `;

					slider.appendChild(div);
				});

				currentImages = images;
			}

			// Initialize from URL hash when available, else default to "All"
			const hashCollectionIndex = getCollectionIndexFromHash(window.location.hash);
			const initialCollectionIndex =
				hashCollectionIndex >= 0 ? hashCollectionIndex : 0;
			setActiveCollection(initialCollectionIndex, {
				scroll: hashCollectionIndex >= 0,
			});

			// Setup click handlers on filter links
			collectionsLinks.forEach((link) => {
				link.addEventListener("click", (e) => {
					e.preventDefault();

					const target = parseInt(link.dataset.galleryTarget, 10);
					setActiveCollection(target, { scroll: true, syncHash: true });
				});
			});

			window.addEventListener("hashchange", () => {
				const hashIndex = getCollectionIndexFromHash(window.location.hash);
				setActiveCollection(hashIndex >= 0 ? hashIndex : 0);
			});

			// Set clickedImageId on modal show (before shown.bs.modal)
			modal.addEventListener("show.bs.modal", (event) => {
				const trigger = event.relatedTarget;
				if (!trigger) return;
				clickedImageId = trigger.dataset.imageId;
			});

			// Initialize Swiper modal when modal shows
			modal.addEventListener("shown.bs.modal", () => {
				swiperWrapper.innerHTML = "";

				let startIndex = 0;

				currentImages.forEach((img, idx) => {
					const slide = document.createElement("div");
					slide.className =
						"swiper-slide d-flex justify-content-center align-items-center text-center";
					slide.innerHTML = `<img src="${
						img.url
					}" class="object-fit-contain mx-auto" alt="${img.alt || ""}">`;
					swiperWrapper.appendChild(slide);

					if (String(img.id) === String(clickedImageId)) {
						startIndex = idx;
					}
				});

				// Destroy previous instance cleanly
				if (modalSwiper) {
					modalSwiper.destroy(true, true);
					modalSwiper = null;
				}

				modalSwiper = new Swiper(".modal-swiper", {
					slidesPerView: 1,
					initialSlide: startIndex,
					centeredSlides: true,
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
					keyboard: { enabled: true },
					effect: "fade",
					fadeEffect: { crossFade: true },
					modules: [Navigation, Keyboard, EffectFade],
					observer: true,
					observeParents: true,
				});

				// Force correct sizing & slide position
				modalSwiper.update();
				modalSwiper.slideTo(startIndex, 0, false);
			});
		}
	}
});

// jQuery-specifc code
jQuery(function ($) {
	// Menu Dropdowns
	/*
	var svgOpen =
		'<div class="dropdown-trigger position-absolute top-50 start-100 translate-middle text-center lh-1"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24"><path fill="none" stroke="#ffffff" stroke-width="12" stroke-linecap="round" stroke-linejoin="round" d="M128 192l128 128 128-128"/></svg></div>';
	$("#main-nav .menu-item.dropdown").each(function () {
		// Appends the dropdown arrow
		$(this).append(svgOpen);
	});
	*/
	$("#main-nav .menu-item .dropdown-trigger").click(function () {
		// Toggles the dropdown
		$(this).siblings(".dropdown-menu").toggleClass("show");
	});
	// If #main-nav a.menu-item link is "#", open the dropdown instead of going to "#"
	$("#main-nav .menu-item a.nav-link").click(function (e) {
		if ($(this).attr("href") === "#") {
			e.preventDefault();
			$(this).siblings(".dropdown-menu").toggleClass("show");
		}
	});

	// Testimonials Block Slider
	if ($(".swiper-testimonials").length) {
		$(".swiper-testimonials").each(function () {
			new Swiper(this, {
				direction: "horizontal",
				autoHeight: true,
				loop: true,
				speed: 500,
				slidesPerView: 1,
				effect: "fade",
				modules: [Navigation, EffectFade],
				fadeEffect: {
					crossFade: true,
				},
				navigation: {
					nextEl: $(this).find(".swiper-button-next")[0],
					prevEl: $(this).find(".swiper-button-prev")[0],
				},
			});
		});
	}

	// Scrollspy classes
	$(".slide-in-bottom-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-bottom-medium; delay: 100",
	);
	$(".slide-in-left-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-left-medium; delay: 100",
	);
	$(".slide-in-right-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-right-medium; delay: 100",
	);
	$(".slide-in-bottom-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-bottom-small; delay: 100",
	);
	$(".slide-in-left-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-left-small; delay: 100",
	);
	$(".slide-in-right-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-right-small; delay: 100",
	);
	$(".fade-in").attr("uk-scrollspy", "cls: uk-animation-fade; delay: 100");
	$(".fade-in-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-fade; delay: 100",
	);
	$(".slide-in-bottom-sm-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-bottom-small; delay: 100",
	);
	$(".slide-in-bottom-md-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-bottom-medium; delay: 100",
	);
	$(".slide-in-left-sm-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-left-small; delay: 100",
	);

	// toTopButton
	if ($("#toTopButton").length) {
		$(window).on("scroll", function () {
			if ($(this).scrollTop() > 600) {
				$("#toTopButton").removeClass("hidden");
			} else {
				$("#toTopButton").addClass("hidden");
			}
		});
		// Smoothly scroll back to top when the button is clicked
		$("#toTopButton").on("click", function (event) {
			event.preventDefault();
			window.scrollTo({ top: 0, behavior: "smooth" });
		});
	}
});
